import axios from 'axios'
import { CMSApiResponseBody } from 'types/cms/request'
import { Language } from 'types/language'
import { CmsDynamicTariffPage } from 'types/cms/single-types'

/**
 * Get the dynamic tariff page from the CMS
 *
 * @param {Language} locale
 * @returns {Promise<CmsDynamicTariffPage | undefined>}
 */
const getDynamicTariffPage = async (locale: Language = Language.DUTCH): Promise<CmsDynamicTariffPage | undefined> => {
  try {
    const {
      data: { data }
    } = await axios.get<CMSApiResponseBody<CmsDynamicTariffPage>>(`${process.env.CMS_API_URL}/dynamic-tariff?locale=${locale}`)

    return data
  } catch (_) {
    return undefined
  }
}

export default getDynamicTariffPage
